export const algoliaClickHit = ({ index, queryID, hit, collectionName, collectionType, hierarchyPath, position, query }) => {
    window.dataLayer.push({
        event: 'alg_click_hit',
        algolia_click: {
            index,
            queryID,
            objectIDs: [hit.objectID],
            positions: [position],
            hit: {
                ...hit,
                collection_name: collectionName,
                collection_type: collectionType,
                hierarchy_path: hierarchyPath ?? collectionName,
                search_term: query,
                position
            }
        }
    });
    window.Cookies.set('alg_last_queryID', queryID, { expires: 1, sameSite: 'lax' });
    window.Cookies.set('alg_last_index', index, { expires: 1, sameSite: 'lax' });
};
